import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { SearchTypeService } from '../_services/search/search-type.service';
import { HomeService } from 'src/services/Home';
import { CommonService } from '../_services/listing/common.service';
import { Title } from '@angular/platform-browser';
import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, flipInX } from 'ng-animate';
import { ToasterService } from '../_services/toaster.service';
import { MyPropertyService } from 'src/services/my-property';
import { PropertiesService } from 'src/services/Properties';
import { CanonicalService } from '../shared/canonical.service';
import { NiceScrollService } from '../_services/nice-scroll.service';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.html',
    styleUrls: ['./home.component.css'],
    animations: [
        trigger('bounce', [transition('* => *', useAnimation(bounce))]),
        trigger('flipInX', [transition('* => *', useAnimation(flipInX))]),
    ],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private homeService: HomeService,
    private titleService: Title,
    private toasterService: ToasterService,
    private canonicalService: CanonicalService,
    private propertyService: PropertiesService,
    private niceScroll: NiceScrollService,
    private searchType: SearchTypeService,
    private commonService: CommonService
    ) {
    }

  PropertyCities: Array<any> = [{ Id: 0, Text: 'All Cities' }];
  PropertyLocations: Array<any> = [{ CityId: 0, Id: 0, Text: 'All Locations' }];
  AllPropertyLocations: Array<any> = [{ CityId: 0, Id: 0, Text: 'All Locations' }];
  AreaUnits: Array<any>;
  PropertyTypeArray: Array<any> = [];
  BedRoomsDropdownData: Array<any> = [];
  BathRoomsDropdown: Array<any> = [];

  Locations: Array<any> = [];
  Purpose = 0;
  City = 0;
  AreaUnit = 0;
  PropertyType = 0;
  MinPrice;
  MaxPrice;
  MinArea;
  MaxArea;
  BedRooms;
  BathRooms;
  MostPopularPlaces: [];
  WhatOurClientSays: [];
  NewlyAddedParentObject: [];
  IsLoading = false;


  ngOnInit() {
    this.titleService.setTitle('Home | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
    this.Locations.push(0);
    this.PopulateDropdownOnStart();
    this.NewlyAddedMethod();
    this.MostPopularPlacesMethod();
    this.WhatOurClientSaysMethod();
  }

  ngAfterViewInit() {
    this.searchType.Render();
    this.commonService.RenderListingCarousel();
  }

  PopulateDropdownOnStart() {
    const endPoint = 'GetDropDownData';
    this.homeService.GetService(endPoint).subscribe(data => {
      this.PropertyCities = data.Cities;
      this.PropertyTypeArray = data.Types;
      this.BedRoomsDropdownData = data.BedRooms;
      this.BathRoomsDropdown = data.BathRooms;
      this.AreaUnits = data.AreaUnits;
    });
  }

  SearchProperty() {
    this.router.navigate(['/properties'], {
      queryParams: {
        Purpose: this.Purpose,
        City: this.City,
        Location: this.Locations.join(','),
        PropertyType: this.PropertyType,
        MinPrice: this.MinPrice,
        MaxPrice: this.MaxPrice,
        AreaUnit: this.AreaUnit,
        MinArea: this.MinArea,
        MaxArea: this.MaxArea,
        BedRooms: this.BedRooms,
        BathRooms: this.BathRooms,
      }
    });
  }

  onRadioItemChange(value: number) {
    this.Purpose = value;
  }

  cityLocations() {
    // tslint:disable-next-line: triple-equals
    if (this.City != null && this.City != 0) {
      this.propertyService.getLocationsByCityId(this.City).subscribe(locations => {
        this.PropertyLocations = locations;
        this.Locations = [];
        if (locations.length === 1) {
          this.Locations.push(locations[0].Id);
        } else if (this.City === 0) {
          this.PropertyLocations = this.AllPropertyLocations;
          this.Locations = [];
          this.Locations.push(0);
        }
      });
      // tslint:disable-next-line: triple-equals
    } else if (this.City == 0) {
      this.PropertyLocations = this.AllPropertyLocations;
      this.Locations = [];
      this.Locations.push(0);
    } else {
      this.PropertyLocations = this.AllPropertyLocations;
      this.Locations = [];
    }
  }


  MostPopularPlacesMethod() {
    this.homeService.HomeGetService('MostPopularPlaces').subscribe(data => {
      this.MostPopularPlaces = data;
    });
  }

  WhatOurClientSaysMethod() {
    this.homeService.HomeGetService('WhatOurClientSays').subscribe(data => {
      this.WhatOurClientSays = data;
    });
  }


  NewlyAddedMethod() {
    this.IsLoading = true;
    this.homeService.HomeGetService('NewlyAdded').subscribe(data => {
      this.NewlyAddedParentObject = data;
      this.commonService.RenderListingCarousel();
      this.IsLoading = false;
    });
  }


  PriceORAreaOnChange(Param: string) {
    if (Param === 'Area') {
      if (this.MaxArea !== undefined && this.MinArea !== undefined) {
        // tslint:disable-next-line: radix
        if (parseInt(this.MinArea.replace(/,/g, '')) > parseInt(this.MaxArea.replace(/,/g, ''))) {
          // tslint:disable-next-line: max-line-length
          this.toasterService.Warning('Min area should be less than or equal to max area.', 'Search may not work properly, please fix the below warning!');
        }
      }
    }
    if (Param === 'Price') {
      if (this.MaxPrice !== undefined && this.MinPrice !== undefined) {
        // tslint:disable-next-line: radix
        if (parseInt(this.MinPrice.replace(/,/g, '')) > parseInt(this.MaxPrice.replace(/,/g, ''))) {
          // tslint:disable-next-line: max-line-length
          this.toasterService.Warning('Min price should be less than or equal to max price.', 'Search may not work properly, please fix the below warning!');
        }
      }
    }
  }
}
